// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_3x-0";
export var eligibilityCardNotEligible = "_3x-1";